const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/auth/admin-access/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/auth/admin-access/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: (search): {
    session?: string;
  } => ({
    session: typeof search.session === 'string' ? search.session : undefined
  })
});

/**
 * 대리 접속 새 탭의 첫 화면. 주소의 세션 ID 로 토큰을 받아 대상 계정의 첫 화면으로 보낸다.
 * 토큰은 주소에 싣지 않는다.
 */
export function TSRDummyComponent() {
  return null;
}